import { useState } from 'react'
import Header from './components/Header'
import FilterBar from './components/FilterBar'
import NewsList from './components/NewsList'
import { NewsFilter, GameType, NewsSource } from './types'

function App() {
  const [filter, setFilter] = useState<NewsFilter>({
    games: ['all'],
    sources: [],
    keyword: ''
  })

  const handleGameChange = (games: GameType[]) => {
    setFilter(prev => ({ ...prev, games }))
  }

  const handleSourceChange = (sources: NewsSource[]) => {
    setFilter(prev => ({ ...prev, sources }))
  }

  const handleKeywordChange = (keyword: string) => {
    setFilter(prev => ({ ...prev, keyword }))
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900">
      <Header />
      <main className="container mx-auto px-4 py-8">
        <FilterBar 
          filter={filter}
          onGameChange={handleGameChange}
          onSourceChange={handleSourceChange}
          onKeywordChange={handleKeywordChange}
        />
        <NewsList filter={filter} />
      </main>
      <footer className="text-center py-6 text-white/60 text-sm">
        <p>数据来源于米哈游官方渠道，仅供参考</p>
        <p className="mt-2">
          <a href="https://github.com" target="_blank" rel="noopener noreferrer" className="hover:text-white">
            GitHub 开源项目
          </a>
        </p>
      </footer>
    </div>
  )
}

export default App
